<template>
  <div class="edit-predicted-wo-actual-popup-flow">
    <edit-predicted-expense-w-o-actual v-if="currentComponent === componentNames.editPredicted"
                                         :predicted-transaction="predictedTransaction"
                                         :close-action="closeAction"
                                         :change-expense-category="changeExpenseCategory"
                                         :fixed-expense-categories="fixedExpenseCategories" />

    <edit-predicted-transaction-summary v-if="currentComponent === componentNames.editSummary"
                                     :predicted-transaction="predictedTransaction"
                                     :old-expense-category="oldExpenseCategory"
                                     :new-expense-category="newExpenseCategory"
                                     :close-action="closeAction"
                                     :back-action="back" />
  </div>
</template>

<script>
import _ from 'lodash';
import Segment from '../../../../../../../../../../../../Segment';
import EditPredictedExpenseWOActual from '../EditPredictedExpenseWOActual.vue';
import EditPredictedTransactionSummary from '../EditPredictedTransactionSummary.vue';
import consts from '../../../../../../../../../../../../constants/cashflow-view';

const componentNames = {
  editPredicted: 'edit-predicted',
  editSummary: 'edit-summary',
};

export default {
  name: 'EditPredictedWOActualFlow',
  components: {
    EditPredictedExpenseWOActual,
    EditPredictedTransactionSummary,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentComponent: componentNames.editPredicted,
      oldExpenseCategory: this.predictedTransaction.expense,
      newExpenseCategory: null,
    };
  },
  computed: {
    componentNames() {
      return componentNames;
    },
    fixedExpenseCategories() {
      if (_.includes(consts.NON_TRANSFERABLE_FIXED_EXPENSE_CATEGORIES, this.predictedTransaction.expense)) {
        return _.concat(this.predictedTransaction.expense, consts.TRANSFERABLE_FIXED_EXPENSE_CATEGORIES);
      }
      return consts.TRANSFERABLE_FIXED_EXPENSE_CATEGORIES;
    },
  },
  methods: {
    setNewExpenseCategory(newExpenseCategory) {
      this.newExpenseCategory = newExpenseCategory;
    },
    closeAction() {
      Segment.trackUserInteraction('EditPredictedWOActualFlow_Closed', {
        predictedTransaction: this.predictedTransaction,
      });
      this.$emit('close');
    },
    back() {
      this.currentComponent = componentNames.editPredicted;
    },
    changeExpenseCategory(newExpenseCategory) {
      this.newExpenseCategory = newExpenseCategory;
      this.currentComponent = componentNames.editSummary;
    },
  },
};
</script>
